import './App.css';
import { useNavigate } from 'react-router-dom';
import { Message } from './components';
import { useEffect, useState } from 'react';
import Icon, { MenuOutlined,  PlusCircleFilled , MinusCircleFilled, ArrowLeftOutlined, SearchOutlined} from '@ant-design/icons';
import { Button, DatePicker, Drawer, Form, Input, InputNumber, Menu, Popconfirm, Select, Switch, Table, Tooltip } from 'antd';
import { menu, usePreventScrollRefresh } from './Dash';
import { addMovementsFunction, checkLogIn, csvExport, getCausal, getEnterpriseInfo, getMovements, getOperators, getStore, getSuppliers, messageGeneral, removeMovements } from './Functions';
import { useForm } from 'antd/es/form/Form';
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";

import "dayjs/locale/it";
import locale from "antd/es/locale/it_IT";
dayjs.extend(utc)

var filters = {
  tokenUser : null,
  tokenCustomer : null,
  tokenSupplier : null,
  tokenPointOfSale : null,
  tokenPointOfSaleCompany : null,
  movementType : null,
  movementDateStart : null,
  movementDateEnd  : null,
  skip : 0,
  take : 1000
}


const columnsTable = [
  {
    title: 'Data',
    dataIndex: 'movementDate', 
  },
  {
    title: 'Operatore',
    dataIndex: 'operatorName' 
  },
  {
    title: 'P. vendita',
    dataIndex: 'pointOfSale' 
  },
  {
    title: 'Azienda',
    dataIndex: 'company' 
  },
  {
    title: 'Causale',
    dataIndex: 'causal',
  },
  {
    title: 'Tipo',
    dataIndex: 'movementType',
  },
  {
    title: 'Fornitore/Clienti',
    dataIndex: 'supplier',
  },
  {
    title: 'Imponibile',
    dataIndex: 'amount',
  },
  {
    title: 'Totale IVA',
    dataIndex: 'amountTaxable',
  },
  {
    title: 'Totale Fattura',
    dataIndex: 'amountTotal',
  },
  {
    title: 'Numero Documento',
    dataIndex: 'movementNumber',
  },
  {
    title: 'Documento del',
    dataIndex: 'docDate',
  },
  {
    title: 'Nota',
    dataIndex: 'title',
  },
]


function Movements() {
  usePreventScrollRefresh();

  const navigate = useNavigate();
  const [addMovements, setAddMovements] = useState( getEnterpriseInfo().role == 'operator' ? true : false);
  const [openMessage, setOpenMessage]   = useState(false);
  const [message, setMessage]           = useState('');
  const [openDrawer, setOpenDrawer]     = useState(false)
  const [movements, setMovements]       = useState([])

  const [storeOptions,      setStoreOptions]     = useState([]);
  const [operatorsOptions,  setoperatorsOptions] = useState([]);
  const [suppliersOptions, setSuppliersOptions] = useState([]);
  const [causalOptions,    setCausalOptions]    = useState([]);
  const [pointOfSaleOptions,    setPointOfSale]    = useState([]);

  const [context, start ]             = messageGeneral();
  const [form] = useForm()
  const [formDateFilter] = useForm()
  const [selectionType, setSelectionType] = useState('checkbox');
  const [rowSelected, setSelectedRow] = useState([])
  const [showTableSmart, setShowTableSmart] = useState(true)

  const [causals, setCausals] = useState([])
  const [causalsToken, setCausalsToken] = useState('')
  const [forCompany, setForCompany]   = useState(false)

  const [companies, setCompanies]           = useState([])
  
  async function getComapies() {

      let companiesTemp = [];
      (await getStore(true)).forEach(s => {
        companiesTemp.push({label: s.businessName , value: s.token })
      });
      setCompanies( companiesTemp );
    }

  useEffect(()=>{
    form.resetFields(['pointOfSale'])
  },[forCompany])

  useEffect(()=>{
    console.log('ok')
  }, [form])
  
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRow(selectedRows);
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: record => ({
      disabled: record.name === 'Disabled User', // Column configuration not to be checked
      name:     record.name,
    }),
  };

  async function firstStart() {
    await getComapies()
    await callFilters();
    formDateFilter.setFieldValue('startDate', dayjs().startOf("month"))
    formDateFilter.setFieldValue('endDate',   dayjs())
    filters.movementDateStart = dayjs().startOf("month").utc(true).toISOString();
    filters.movementDateEnd = dayjs().utc(true).toISOString();
    await callMovements()
    const role = getEnterpriseInfo().role;
    const tokenPoint = getEnterpriseInfo().tokenPointOfSale;
    if(role == 'administrator') return;
    form.setFieldValue('pointOfSale', tokenPoint )
  }

  async function callFilters() {
    let operators_temp      = await getOperators();
    let stores_temp         = await getStore();
    let suppliers_temp      = await getSuppliers();
    let causal_temp         = await getCausal();
    let pointOfSale_temp    = await getStore();
    setCausals(causal_temp);

    let stores__               = [];
    let operators__            = [];
    let suppliers__            = [];
    let causal__               = [];
    let pointOfsale__          = [];

    stores__.push({label: 'Tutti', value : null})
    operators__.push({label: 'Tutti', value : null})
    suppliers__.push({label: 'Tutti', value : null})
    causal__.push({label: 'Tutti', value : null})


    stores_temp.forEach(store => {
      stores__.push({label: '(PV) '+store.businessName, value : store.token})
    });

    operators_temp.forEach(ope => {
      operators__.push({label: ope.name, value : ope.token})
    });

    suppliers_temp.forEach(ope => {
      suppliers__.push({label: ope.businessName, value : ope.token})
    });

    causal_temp.forEach(ope => {
      causal__.push({label: ope.name, value : ope.token})
    });

    pointOfSale_temp.forEach(ope => {
      pointOfsale__.push({label: ope.name, value : ope.token})
    });

    setStoreOptions([...stores__]);
    setoperatorsOptions(operators__);
    setSuppliersOptions(suppliers__);
    setCausalOptions(causal__);
    setPointOfSale(pointOfsale__);
  }

  useEffect(() => {
    if(checkLogIn() == null ) navigate('/');
    firstStart()
  },[])

  async function callMovements( /* tokenUser, tokenCustomer,tokenSupplier, tokenPointOfSale, movementType, movementDateStart, movementDateEnd , skip, take */ ) {
    try{
      if( filters.movementDateStart == null || filters.movementDateEnd == null ){
        start('Seleziona date per la ricerca')
        return;
      };
      setSelectedRow([]);
      const movements_ = await getMovements( filters.tokenUser, filters.tokenCustomer, filters.tokenSupplier, filters.tokenPointOfSale, filters.movementType, filters.movementDateStart, filters.movementDateEnd, 0, 1000, filters.tokenPointOfSaleCompany )
      console.log( movements_ )
      movements_.map((m, index)=>{
        m.key = index;
        m.movementDate = (m.movementDate ?? '').split('T')[0].split('-').reverse().join('-');
        m.docDate = (m.docDate ?? '').split('T')[0].split('-').reverse().join('-');
        let causal = JSON.parse(m.metadata ?? JSON.stringify({nameCausal:''}) );

        m.pointOfSale = m.pointOfSale.businessName;
        m.company =  m.company.businessName;


        m.supplier = m.supplier.businessName;
        m.causal = causal.nameCausal;
        const t = m.movementType == 'neutral' ? 'Neutro' : m.movementType == 'cashed' ? 'Entrata' : 'Uscita';
        m.movementType = t;
        m.amountTotal = Math.ceil( Number(m.amount)  + Number( m.amountTaxable) );
      })
      setMovements( movements_ );
    
    }catch(err){
      console.log( err)
    }
  }


async function register(values) {
  try{
    const { date, causal, supplier, amount, amountTaxable, documentNumber, docDate , title, pointOfSale,tokenPointOfSaleCompany  } = values;

    const add = await addMovementsFunction(title, date.utc(true).toISOString() , documentNumber, amountTaxable, amount, causal, null, null, supplier, docDate ? docDate.utc(true).toISOString() : null,pointOfSale ,tokenPointOfSaleCompany)
    if( add ){
      form.resetFields()
      start('Movimento aggiunto')
      return;
    }
    start('ATTENZIONE ERRORE GENERAZIONE MOVIMENTO')
  }catch( err ){
    console.log( err)
  }
  
}

  function control ( input ) {
    const index = causals.findIndex((c)=> c.token == causalsToken);
    if( index == -1 ) return false;
    return causals[index][input] == 1 ? true : false;
  }
    const ConfermaEliminazione = ( child  ) => {
    
      async function remove() {
        if( rowSelected.length == 0 )return;
        await Promise.all(rowSelected.map(async (move) => await removeMovements(move.token)));
        await callMovements()
      }
    
      return (
        <Popconfirm
          title="Sei sicuro di voler eliminare i movimenti selezionati?"
          onConfirm={
            ()=> 
            remove()}
          okText="Sì"
          cancelText="No"
        >
          { child }
        </Popconfirm>
      );
    };

  return (
    <div className="center bg-color-primary all-viewport">
      {context}
      {
         Message( message, openMessage, ()=> setOpenMessage(false))
      }
      <div onClick={()=> setOpenDrawer(true)} style={{position:'fixed', top: '10px', left:'10px'}}>
        <MenuOutlined style={{fontSize:'30px',color: 'rgba(52, 121, 57, 1)'}} />
      </div>
      <div style={{position:'fixed', top:'10px'}}> <Button key={'closeTable'} className='button-close-table-smart' onClick={()=> setShowTableSmart(!showTableSmart)}>{  showTableSmart ? "Chiudi" : 'Tabella'}</Button> </div>
      <div style={{position:'fixed', top: '10px', right:'10px'}}>
        {

          addMovements 
          ?
          < ArrowLeftOutlined  onClick={() => setAddMovements(false)} style={{fontSize:'30px', color: 'rgba(52, 121, 57, 1)'}} />


          : 
          < PlusCircleFilled onClick={() => setAddMovements(true)} style={{fontSize:'30px',color: 'rgba(52, 121, 57, 1)'}} />
        }
      </div>
      
      <div className='table-smart' style={{position:'fixed', left:0, top:0,  height:'100%', width:'10%', backgroundColor:'white', zIndex: 20}}>
        {
           menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
                className='center'
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'15px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )}
      </div>
       <Drawer
        className='bg-color-secondary'
        placement='left'
        open={openDrawer}
        onClose={()=> setOpenDrawer(false)}
      >
        <div style={{height:'100%', width: '100%', overflowY: 'auto'}}>
          {
            menu.map((m, index) => 
            {
             
              return <div 
              onClick={() => {
                navigate(m.path);
                }}
              style={{ display: (getEnterpriseInfo() != null &&  getEnterpriseInfo().role == 'operator' && index != 0 && m.path != '/') ? 'none' :'',  height:'50px', fontSize:'20px', color:  m.path == '/' ? 'red' : 'black', fontWeight:'bold', cursor:'pointer', }} 
            
            > {m.title} </div>}
          
          )
          }
        </div>
      </Drawer> 
          
       {
      addMovements
       ?
       
       /* --------------------------------AGGIUNGI MOVIMENTO--------------------------------------------- */
        <Form
            requiredMark={true}
            form={form}
            style={{height:'90%', overflowY:'auto', scrollbarColor:'', }}
            onFinish={register}
          >
            <div className='center text-style' style={{ marginBottom:'10px', backgroundColor:''}}> Aggiungi movimento </div>
            <span>
              
            </span>
            <label  className='text-color-one'>Causale</label>
            <Tooltip className='text-color-one' style={{}}>*</Tooltip>
            <Form.Item
                name="causal"
                rules={[{ required: true, message: 'Seleziona causale' }]} 
              >
              <Select onChange={(v) => setCausalsToken(v)} options={causalOptions} className='input-style' placeholder='Seleziona causale'></Select>
            </Form.Item>
            
            <label className='text-color-one'>Data movimento</label>
            <Tooltip className='text-color-one' style={{}}>*</Tooltip>
            <Form.Item
                name="date"
                rules={[{ required: true, message: 'Seleziona data' }]}
              >
                <DatePicker placeholder='Data movimento' className='input-style' style={{ width:'100%', height:'100%' }} onChange={(date) => { console.log(date)}} />
                
            </Form.Item>
              <>
                <label  className='text-color-one'>Azienda</label>
                <Tooltip className='text-color-one' >*</Tooltip>
                <Form.Item
                    name="tokenPointOfSaleCompany"
                    rules={[{ required: true, message: 'Seleziona azienda' }]} 
                  >
                  <Select options={companies} className='input-style' placeholder='Azienda'></Select>
                </Form.Item>
              </>
            <>
              <label  className='text-color-one'>Punto vendita</label>
              <Tooltip className='text-color-one' >*</Tooltip>
              <Form.Item
                  name="pointOfSale"
                  rules={[{ required: true, message: 'Seleziona punto vendita' }]} 
                >
                <Select options={pointOfSaleOptions} className='input-style' placeholder='Punto vendita'></Select>
              </Form.Item>
            </>
            
            {
                  //OPERATORE
                }

            {
                  //uscita entrata neutro
            }
            <label  className='text-color-one'>Fornitore</label>
            {
              control( 'mandatorySupplier' )
               ?
              <Tooltip className='text-color-one' >*</Tooltip>
              :<></>
            }
            <Form.Item
                name="supplier"
                rules={[{ required: control( 'mandatorySupplier' ), message: 'Seleziona fornitore' }]} 
              >
              <Select options={suppliersOptions} className='input-style' placeholder='Seleziona fornitore'></Select>
            </Form.Item>

            <label  className='text-color-one'>Imponibile</label>
            {
              control( 'mandatoryAmount' )
               ?
              <Tooltip className='text-color-one' >*</Tooltip>
              :<></>
            }
            <Form.Item
               name="amount"
               rules={[{ required: control( 'mandatoryAmount' ), message: 'Importo totale' }]} 
              >
              <InputNumber className='input-style' inputmode="numeric" placeholder='Imponibile'></InputNumber>
            </Form.Item>

            <label  className='text-color-one'>Totale IVA</label>
            {
              control( 'mandatoryAmountTaxable' )
               ?
              <Tooltip className='text-color-one' >*</Tooltip>
              :<></>
            }
            <Form.Item
                name="amountTaxable"
                rules={[{ required: control( 'mandatoryAmountTaxable' ), message: 'Inserire totale iva' }]}
              >
              <InputNumber inputmode="numeric" className='input-style' placeholder='Totale IVA'></InputNumber>
            </Form.Item>

            <label  className='text-color-one'>Numero documento</label>
            {
              control( 'mandatoryBillNumber' )
               ?
              <Tooltip className='text-color-one' >*</Tooltip>
              :<></>
            }
            <Form.Item
                name="documentNumber"
                rules={[{ required: control( 'mandatoryBillNumber' ), message: 'Numero documenti' }]} 
              >
              <Input className='input-style' placeholder='Numero documento'></Input>
            </Form.Item>


            <label  className='text-color-one'>Data documento</label>
            {
              control( 'mandatoryDocumentDate' )
               ?
              <Tooltip className='text-color-one' >*</Tooltip>
              :<></>
            }
            <Form.Item
                name="docDate"
                rules={[{ required: control( 'mandatoryDocumentDate' ), message: 'Seleziona data documento' }]}
              >
                <DatePicker placeholder='Data documento' className='input-style' style={{ width:'100%', height:'100%' }} onChange={(date) => { console.log(date)}} />
            </Form.Item>

            <label  className='text-color-one'>Nota</label>
            {
              control( 'mandatoryTitle' )
               ?
              <Tooltip className='text-color-one' >*</Tooltip>
              :<></>
            }
            <Form.Item
                name="title"
                rules={[{ required: control( 'mandatoryTitle' ), message: 'Inserire nota' }]}
              >
                <Input placeholder='Nota' className='input-style' style={{ width:'100%', height:'100%' }} onChange={(date) => { console.log(date)}} />
            </Form.Item> 
              <p style={{ color: "red", fontWeight: "bold" }}>
                I campi con * sono obbligatori
              </p>
            <Button
              className='input-style color-one'
              type="primary" 
              htmlType="submit">
              Aggiungi </Button>

              <div style={{height:'50px'}}></div>
            </Form>
          : 
          <div  style={{ height:'100%',  width:'100%', justifyContent:'end', backgroundColor:''}} className='center list-filter-smart'> 
            <div style={{ height:'90%', width:'90%', backgroundColor:'' }}>
            <div className='center text-style' style={{ marginBottom:'10px'}}> Lista movimenti </div>

            <div className='center boxSmartphone' style={{ gap:'10px', display:'flex', alignItems:'center'}}>
              {/* -----------------------DATE START END---------------------------------- */}
              <Form form={formDateFilter} style={{display:'flex', gap:'10px', backgroundColor:'white', height:'100%'}} >
                <div className='div-intern'>
                  <Form.Item name='startDate' style={{height:'10px'}} >
                    <DatePicker placeholder='Data da..' style={{ width:'100%', height:'100%' }} 
                    onChange={(date) => { 
                      if( date != null ){
                        /* let day = (date.get('date')).toString().padStart(2,'0');
                        let month = (date.get('month') + 1).toString().padStart(2,'0');
                        let year  = (date.get('year'));
                        const date_ = year+'-'+month+'-'+day+'T00:00:00.000Z'; */
                        filters.movementDateStart = date.utc(true).toISOString();
                        return;
                      }
                        filters.movementDateStart = null;
                    }} />
                  </Form.Item>  
                </div>

                <div className='div-intern'>
                <Form.Item name='endDate' style={{height:'10px'}} >
                  <DatePicker
                    placeholder='Data al..'
                    onChange={(date) => { 
                      if( date != null ){
                        filters.movementDateEnd = date.utc(true).toISOString();
                        return;
                      }
                        filters.movementDateEnd = null;
                    }}
                    style={{ width:'100%', height:'100%' }} />

                  </Form.Item> 
                  </div>
              </Form>
              {/* -----------------------OPERATORS---------------------------------- */}
              
              {
                getEnterpriseInfo().role == 'operator' ?
                
                <></>
                :
                <div className='div-intern'style={{minWidth:'130px'}}> 
                <Select
                allowClear
                onChange={(v)=> filters.tokenUser = v}
                options={operatorsOptions}
                placeholder='Operatore' style={{ width:'100%', height:'100%' }}/></div>}
              
              {/* -----------------------store---------------------------------- */}

              
              <div className='div-intern'style={{minWidth:'200px'}}> <Select
              
              onChange={(v)=> filters.tokenPointOfSale = v}
              allowClear 
              options={storeOptions}
              placeholder='Punto vendita' style={{ width:'100%', height:'100%' }}></Select> </div>

              

               {/* -----------------------azienda---------------------------------- */}
              <div className='div-intern'style={{minWidth:'130px'}}> <Select
                allowClear 
                onChange={(v)=> filters.tokenPointOfSaleCompany = v}
               options={companies}
               placeholder='Azienda' style={{ width:'100%', height:'100%' }}></Select> </div> 
                {/* -----------------------Fornitore---------------------------------- */}
              <div className='div-intern'style={{minWidth:'130px'}}> <Select
              onChange={(v)=> filters.tokenSupplier = v}
               options={suppliersOptions}
               placeholder='Fornitore' style={{ width:'100%', height:'100%' }}></Select> </div>
             
              {/* -----------------------tipo causale---------------------------------- */}
              <div className='div-intern' style={{minWidth:'130px'}}> 
                <Select
                  allowClear
                  onChange={(v)=>{ filters.movementType = v}}
                  options={[
                    { label: 'Tutte',   value: null },
                    { label: 'Entrata', value: 'cashed' },
                    { label: 'Uscita',  value: 'spent' },
                    { label: 'Neutra',  value: 'neutral' },
                  ]}
                  placeholder='Tipo movimento' style={{ width:'100%', height:'100%' }}/>
              </div>
              <div className='div-intern ' style={{minWidth:'130px'}}> <Button onClick={()=> callMovements()} className='div-intern color-one' style={{minWidth:'130px', color:'white'}}>Cerca</Button> </div>
              
              <div className='div-intern ' style={{minWidth:'130px'}}> 
                <Button 
                  disabled={rowSelected.length != 0 ? false : true} 
                  onClick={
                    async () => {
                      if( filters.movementDateEnd == null || filters.movementDateStart == null ) return;
                      let ok = await csvExport(rowSelected, 'Report_'+filters.movementDateStart.split('T')[0].split('-').reverse().join('-')+'_'+filters.movementDateEnd.split('T')[0].split('-').reverse().join('-'));
                      if( ok ){

                      }
                   }} 
                   className='div-intern color-two' style={{minWidth:'130px', color:'white'}}>
                    CSV</Button> 
              </div>
              
              <div className='div-intern ' style={{minWidth:'130px'}}>
                {
                  ConfermaEliminazione( <Button
                    disabled={rowSelected.length != 0 ? false : true} 
                    onClick={ async ()=>  {

                    }} 
                    className='div-intern color-one' 
                    style={{minWidth:'130px', color:'white', backgroundColor:'red'}}>
                      Elimina
                  </Button> )
                } 
               </div>

            </div>
            <div style={{height:'20px'}}></div>
            {/* <div className='center' style={{ width:'100%', fontSize:'35px', color:'white'}}> ^ </div> */}
            <div className='table-smart' style={{overflowX:'auto', overflowY:'auto', maxWidth:'100%',}}>
              <Table
                rowSelection={Object.assign({ type: selectionType }, rowSelection)}
                style={{minWidth:'130px', backgroundColor:'white'}}
                columns={columnsTable}
                dataSource={movements}
              />
            </div>
            </div>
            
             {/* TABELLA SMART */}
            <div className='table-for-smart' style={{ display:showTableSmart ?'':'none', top:'50px', overflowX:'auto', overflowY:'auto', width:'100%', height:'100%',backgroundColor:'white',  position:'absolute'}}>
              
              <Table
                pagination={false}
                rowSelection={Object.assign({ type: selectionType }, rowSelection)}
                style={{minWidth:'130px', backgroundColor:'white'}}
                columns={columnsTable}
                dataSource={movements}
              />
            </div>

          </div>
        }

    </div>
  );
}

export default Movements;
